// ============================================
// CONTACT INFORMATION - EDIT THIS FILE
// ============================================

export const contact = {
  // Phone Numbers
  phone: {
    main: "971543552388",           // Main phone number (with country code, no +)
    whatsapp: "971543552388",       // WhatsApp number (with country code, no +)
    display: "+971 54 355 2388"     // How to display the number
  },
  
  // Email
  email: {
    main: "info@tunagwaizi-uae.com",
    sales: "sales@tunagwaizi-uae.com",
    support: "support@tunagwaizi-uae.com"
  },
  
  // Location/Address
  location: {
    address: {
      en: "Dubai, United Arab Emirates",
      ar: "دبي، الإمارات العربية المتحدة"
    },
    city: {
      en: "Dubai",
      ar: "دبي"
    },
    country: {
      en: "UAE",
      ar: "الإمارات"
    },
    coordinates: {
      lat: 25.2048,
      lng: 55.2708
    }
  },
  
  // Business Hours
  hours: {
    en: "Sunday - Thursday: 9:00 AM - 6:00 PM",
    ar: "الأحد - الخميس: 9:00 صباحاً - 6:00 مساءً"
  }
};

// Helper function to create WhatsApp link
export const getWhatsAppLink = (phone, message = '') => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone}${message ? `?text=${encodedMessage}` : ''}`;
};

// Helper function to create phone link
export const getPhoneLink = (phone) => {
  return `tel:+${phone}`;
};

// Helper function to create email link
export const getEmailLink = (email, subject = '', body = '') => {
  const params = new URLSearchParams();
  if (subject) params.append('subject', subject);
  if (body) params.append('body', body);
  return `mailto:${email}${params.toString() ? `?${params.toString()}` : ''}`;
};
